import { useAEMFetch } from "@/hooks/common/fetch/useFetch";
// import { parseParams } from "@/utils/common";

const useAemFetchApi = async (url) => {
  try {
    const res = await useAEMFetch(url).get().json();
    const response = res.data.value instanceof Array ? res.data.value : [];
    return response;
  } catch (e) {
    console.error(e);
  }

}
export const useProductSkuApi = async (urlPrefix, skus) => {
  // return await useAEMFetch(`/bin/midea/shoppingCart/productData?modelNumber=${skus.join(',')}`).get().json();
  return await useAEMFetch(`${urlPrefix}.data.json?modelNumber=${encodeURIComponent(JSON.stringify(skus))}`).get().json();
}

export const useProductAemApi = async (urlPrefix, skus) => {
  return await useAEMFetch(`${urlPrefix}.productdata.json?shopifyId=${encodeURIComponent(JSON.stringify(skus))}`).get().json();
}

export const useProductSkuApiByModelNumber = async (modelNumber, path,isResult) => {
  // Modelnumber由于有，接口参数改成数组传递
  const modelNumberJson = [modelNumber];
  const url = `/bin/midea/querySKU?modelNumber=${encodeURIComponent(JSON.stringify(modelNumberJson))}&path=${path}`;
  if(isResult){
    const res= await useAemFetchApi(url);
    return res
  }
  return await useAEMFetch(url).get().json();
}